/**
 * 发送一条评论
 * @param area_id 评论区ID
 * @param content 评论内容
 * @returns 发送成功的评论
 */
export async function requestCreateComment(
  area_id: number,
  content: string,
  image?: string[]
) {
  return http.post<Comment>('/v1/comment/create', {
    area_id,
    content,
    images: JSON.stringify(image)
  })
}
